<template>
  <div>
    <div>
      <!--style="opacity: 0;"-->
      <div id="printable" style="background-color:white;">
        <!-- <div id="print"> -->
        <!-- <button @click=printToExcel()></button> -->
        <div id="intro-left">
          <div class="row">
            <div class="col-md-9 intro">
              <b>Company name:</b>
              <b style="font-size: 30px; font-style: bold;">{{intro.companyTitle}}</b>
              <br />
              <b>{{intro.documentDescription}}</b>
              <br />
              <br />
            </div>
            <div class="col-md-3 pdf-logo sticky-top">
              <div id="logo">
                <!-- <div
                class="picture"
                :style="{ backgroundImage: `url(${require(`@/assets/images/${image}`)})` }">-->
                <!-- src="data:image/jpeg;base64,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" -->
                <img :src="logoData.src" :alt="logoData.altText" style="float: right;" />
              </div>
            </div>
          </div>
        </div>
        <div class="row"></div>
        <!-- style="border: 2px solid red; margin-bottom: 0px; padding-bottom: 0px;" -->
        <div class="row">
          <div class="col-md-12" id="scale-etc">
            <span class="heading">ASSESSMENT</span>
            <div id="table">
              <div class="container">
                <table width="100%">
                  <tbody>
                    <tr>
                      <th width="60%">Financial Statements Assessment:</th>
                      <td>
                        <b>{{anylasis.rating}}</b>
                      </td>
                    </tr>
                    <tr>
                      <th>Short-term credit risk:</th>
                      <td>
                        <b>{{anylasis.risk}}</b>
                      </td>
                    </tr>
                    <tr>
                      <th>Short-term credit recommendation (up to a maximum of):</th>
                      <td>
                        <b>{{isNaN(anylasis.finalMaxCredit) ? anylasis.finalMaxCredit: NoDecimal(anylasis.finalMaxCredit)}}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p
                  class="mt-2"
                >A manual review of financials is recommended to consider a higher amount.</p>
                <div>
                  <ul id="menu">
                    <li>
                      <b>Rating Scale:</b>
                    </li>
                    <li v-for="(level,Key) in ratingLevels" :key="Key">
                      <span>
                        <span>{{level.level}}</span>
                        = {{level.rating}}
                        <span
                          v-if="Key != Object.keys(ratingLevels).length - 1"
                        >,</span>
                      </span>
                    </li>
                  </ul>
                </div>
                <p>The assessment and recommendation are provided without any obligation or undertaking on the provider's part.</p>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12" id="scale-etc">
            <span class="heading">{{headerData.title}}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div id="table" class="pdleftright">
              <div class="container">
                <table class="table table-download table-borderless" cellpadding="-1" ref="table">
                  <thead>
                    <tr>
                      <th width="40%">(Amounts in {{outputData.currency.name}})</th>
                      <th>{{outputData.currentYear}}</th>
                      <th>{{outputData.previousYear}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="gray">
                      <td colspan="3" class="category">Key Numbers</td>
                    </tr>
                    <tr>
                      <td>Revenue</td>
                      <td>{{ NoDecimal(keyMetricsPercent.revenue.current)}}</td>
                      <td>{{ NoDecimal(keyMetricsPercent.revenue.previous)}}</td>
                    </tr>
                    <tr>
                      <td>EBITDA (un-adjusted)</td>
                      <td>{{ NoDecimal(keyMetricsPercent.EbitdaUnAdjusted.current)}}</td>
                      <td>{{ NoDecimal(keyMetricsPercent.EbitdaUnAdjusted.previous)}}</td>
                    </tr>
                    <tr>
                      <td>Tangible Net Worth</td>
                      <td>{{NoDecimal(keyMetricsPercent.TNWRAW.current)}}</td>
                      <td>{{NoDecimal(keyMetricsPercent.TNWRAW.previous)}}</td>
                    </tr>
                    <tr class="gray">
                      <td colspan="3" class="category">Profitability</td>
                    </tr>
                    <tr>
                      <td>Gross Margin (%)</td>
                      <td>{{ percentage(keyMetricsPercent.grossMargin.current)}}%</td>
                      <td>{{ percentage(keyMetricsPercent.grossMargin.previous)}}%</td>
                    </tr>
                    <tr>
                      <td>EBITDA Margin (%)</td>
                      <td>{{ percentage(keyMetricsPercent.EBITDAMargin.current)}}%</td>
                      <td>{{ percentage(keyMetricsPercent.EBITDAMargin.previous)}}%</td>
                    </tr>
                    <tr>
                      <td>Net Profit Margin</td>
                      <td>{{ percentage(keyMetricsPercent.netProfitMargin.current)}}%</td>
                      <td>{{ percentage(keyMetricsPercent.netProfitMargin.previous)}}%</td>
                    </tr>
                    <tr class="gray">
                      <td colspan="3" class="category">Leverage and Gearing</td>
                    </tr>
                    <tr>
                      <td>Leverage (Total debt ÷ EBITDA)</td>
                      <td>{{ oneDecimal(keyMetricsPercent.LeverageOne.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.LeverageOne.previous)}}</td>
                    </tr>
                    <tr>
                      <td>Leverage (Net debt ÷ Equity)</td>
                      <td>{{ oneDecimal(keyMetricsPercent.LeverageTwo.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.LeverageTwo.previous)}}</td>
                    </tr>
                    <tr class="gray">
                      <td colspan="3" class="category">Coverage</td>
                    </tr>
                    <tr>
                      <td>Interest Coverage (EBITDA ÷ Interest expense)</td>
                      <td>{{ oneDecimal(keyMetricsPercent.InterestCoverage.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.InterestCoverage.previous)}}</td>
                    </tr>
                    <tr>
                      <td>Debt Service Coverage</td>
                      <td>{{ oneDecimal(keyMetricsPercent.debtServiceCoverage.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.debtServiceCoverage.previous)}}</td>
                    </tr>
                    <tr class="gray">
                      <td colspan="3" class="category">Liquidity</td>
                    </tr>
                    <tr>
                      <td>Current ratio (times)</td>
                      <td>{{ oneDecimal(keyMetricsPercent.currentRatio.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.currentRatio.previous)}}</td>
                    </tr>
                    <tr>
                      <td>Quick ratio (times)</td>
                      <td>{{ oneDecimal(keyMetricsPercent.QuickRatio.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.QuickRatio.previous)}}</td>
                    </tr>
                    <!-- <tr>
                      <td>Current Assets Liquidation</td>
                      <td>{{ oneDecimal(keyMetricsPercent.CAL.current)}}</td>
                      <td>{{ oneDecimal(keyMetricsPercent.CAL.previous)}}</td>
                    </tr>-->
                    <tr class="gray">
                      <td colspan="3" class="category">Efficiency</td>
                    </tr>
                    <tr>
                      <td>Cash Conversion Cycle (days)</td>
                      <td>{{ NoDecimal(keyMetricsPercent.cashConversionCycle.current)}}</td>
                      <td>{{ NoDecimal(keyMetricsPercent.cashConversionCycle.previous)}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <br />
            <div class="row" style="margin-left:2%">
              <ol>
                <li>
                  <b>Acronyms:</b>
                </li>
                <li>N/a: numerator or denominator ≤ 0.</li>
                <li>x: times</li>
                <li>STD: Short-term Debt</li>
                <li>LTD: Long-term Debt</li>
                <li>CPLTD: Current Portion of LTD</li>
              </ol>
            </div>
          </div>
        </div>
        <!-- // Credit Profile and Year-over-year Change: -->
        <div class="row">
          <div class="col-md-12" id="scale-etc">
            <span class="heading">Credit Profile and Year-over-year Change</span>
          </div>
          <div class="row">
            <div class="col-md-12" id="scale-etc" style="margin-left:2%">
              <h3>Overview:</h3>
              <ul class="list-unstyled arrow-list">
                <!-- {{oneDecimal(elem.current)}} -->
                <!-- {{oneDecimal(elem.previous)}} -->
                <!-- ({{twoDecimal(elem.yoy)}}% -->
                <li v-for="(elem, index) in overview" :key="index">
                  {{index}} of {{outputData.currency.name}} {{oneDecimal(elem['current'])}} compared to {{outputData.currency.name}} {{oneDecimal(elem['previous'])}} in the preceding year
                  ({{twoDecimal(elem['yoy'])}}%
                  yoy).
                </li>
              </ul>
            </div>
            <div class="col-md-12" id="scale-etc" style="margin-left:2%">
              <h3>Strengths:</h3>
              <ul class="arrow-list">
                <li v-for="(elem, index) in strength" :key="index">{{elem}}</li>
              </ul>
            </div>
            <div class="col-md-12" id="scale-etc" style="margin-left:2%">
              <h3>Weaknesses:</h3>
              <ul class="arrow-list">
                <li v-for="(elem, index) in weaknes" :key="index">{{elem}}</li>
              </ul>
            </div>
          </div>
          <div id="step-2" class>
            <div class="box">
              <div class="box-header border-botom">
                <div class="tittle"></div>
              </div>
              <div class="box-body">
                <section>
                  <p class="desclimer">
                    We define credit risk as the risk that an entity may not meet its financial or contractual obligations.
                    The credit risk assessment produced by our Financial Statements Assessment Tool ("FSAT") is based on
                    analysis of financial statements only and it does not address or adequately capture other risks including
                    but not limited to: Country risk, industry risk, foreign exchange exposure risk, transfer & convertibility
                    risk, commodity price risk, obsolescence risk, refinancing risk, ownership risk, key-man risk, legal risks,
                    environmental risks, sanctions risk, corporate governance risk and corporate social responsibility risks.
                    The assessment also does not factor-in payment experience by creditors, suppliers or financial institutions.
                  </p>
                  <p class="desclimer">
                    FSAT's calculations and assessment are based on information provided and entered by the user which are believed
                    to be accurate and reliable. We cannot independently verify or validate information entered by the user. Because
                    of the possibility of human, technical or mechanical error, all information is presented "as is" without any warranty
                    of any kind. No warranty, express or implied, as to the accuracy, timeliness or completeness is given or made by us,
                    directly or indirectly, in any form or manner whatsoever.
                  </p>
                  <p class="desclimer">
                    The maximum credit recommendation noted in the assessment is for short-term unsecured trade credit. Higher level of
                    credit may be granted based on secured terms or based on a manual review of financial statements and any other relevant
                    factors. The recommendation is not applicable to borrowing or lending transactions.
                  </p>
                  <p class="desclimer">
                    FSAT's assessment does not constitute investment or financial advice. The assessment cannot be used to determine suitability
                    of an investment for a particular investor, and is not intended for use by retail investors. Investors in securities should
                    conduct their own due diligence for purchasing, holding and selling securities.
                  </p>
                  <p class="desclimer">
                    To the extent permitted by law, our employees and officers disclaim liability to any person or entity for any direct, indirect,
                    special, consequential, incidental or compensatory losses, loss of present or future profits, or any damages whatsoever arising
                    from or in connection with the use, or inability to use, the information contained in FSAT assessments. To the extent permitted
                    by law, our employees and officers disclaim liability to any person or entity for any damages caused by negligence on our part
                    or any contingency within or out of control of our employees and officers.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-template row">
        <div class="footer">
          <div class="leftdate">{{this.dates}}</div>
          <div class="disclaimer">
            This was prepared exclusively for {{this.userName}}
            <br />Not for distribution unless permitted.
          </div>
          <div class="pagenum">
            <h4>Page #:pageNum#</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: "generatePDFAssessment",
  // Data to be printed from calling component will be placed here
  props: [
    "intro",
    "title",
    "logoData",
    "outputData",
    "keyMetricsPercent",
    "headerData",
    "exportToExcel",
    "ratingLevels",
    "anylasis",
    "overview",
    "strength",
    "weaknes",
    "user"
  ],
  data() {
    return {
      incomeStatementHeaders: true,
      hide: false,
      exportToExcelExec: this.exportToExcel,
      userName: this.user.name,
      dates: this.$moment().format("YYYY-MM-DD"),
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    };
  },
  mounted() {
    console.log("overview", this.overview);
    this.initializePrinter();
  },
  methods: {
    // print method
    initializePrinter() {
      // console.log(this.props);
      if (this.exportToExcelExec == true) {
        this.initGenerateExcel();
      } else {
        this.printWithKendo();
      }
    },
    printWithKendo() {
      var self = this;
      kendo.drawing
        .drawDOM("#printable", {
          multiPage: true,
          forcePageBreak: ".page-break",
          margin: { left: "1cm", top: "1cm", right: "2cm", bottom: "2cm" },
          paperSize: "A4",
          scale: 0.5,
          height: 500,
          template: kendo.template($(".page-template").html())
        })
        .then(function(group) {
          kendo.drawing.pdf.saveAs(group, "Financial Statment Assessment");
        })
        .then(function() {
          self.$emit("hidePrinter", this.hide);
        });
    },
    initGenerateExcel() {
      var self = this;
      return this.printToExcel()
        .then(function() {
          self.exportToExcel = false;
        })
        .then(function() {
          self.$emit("hidePrinter", self.hide);
        });
    },
    percentage(value) {
      if (value === "N/a") {
        return value;
      } else {
        value = value * 100;
        return this.oneDecimal(value);
      }
    },
    oneDecimal(value) {
      if (value === "N/a" || value === undefined) {
        return value;
      } else {
        value = this.round(value, 1);
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      }
    },
    twoDecimal (value) {
      if (value === 'N/a' || value === undefined) {
        return value
      } else {
        value = value * 100 // take percentage first
        value = this.round(value, 2)
        return value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
      }
    },
    NoDecimal(value) {
      if (value === "N/a") {
        return value;
      } else {
        value = this.round(value, 0);
        value = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
        return value;
      }
    },
    round(value, precision) {
      var multiplier = Math.pow(10, precision || 0);
      return Math.round(value * multiplier) / multiplier;
    },
    printToExcel() {
      var table2excel = new Table2Excel();
      // return new Promise((resolve, reject) => {
      //   resolve(
      //     table2excel.export(document.querySelectorAll("#assessment-table"))
      //   );
      // });
      let table = this.$refs["table"]
      let name = "Financial Assessment"
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      window.location.href = this.uri + this.base64(this.format(this.template, ctx))
    }
  }
};
</script>

<style scoped>
#printable {
  background-color: white;
  font-size: 20px;
  font-family: "Times New Roman", Times, serif;
}
img {
  float: right;
}

th {
  text-align: left;
  padding: 0.1rem;
}
tr {
  margin-top: -20px;
  margin-bottom: -20px;
}
td {
  text-align: left;
  padding: 0.1rem;

  font-size: 22px;
}
.intro {
  padding-top: 5%;
  /* padding-left: 10%; */
  width: 100%;
  height: 100%;
}
.pdf-logo {
  padding-top: 5%;
  padding-right: 100px;
}

#print {
  padding-left: 5%;
  padding-right: 5%;
}
.title {
  /* text-align: center; */
  font-style: bold;
}
#table {
  /* padding: 0.1rem; */
  /* padding-left: 20%;
  padding-right: 15%; */
  width: 90%;
  padding-top: 2%;
  padding-bottom: 2%;
}
table {
  padding: 0.1rem;
}
tbody > td {
  text-align: left;
}
.td_style {
  text-align: left;
  padding-left: 5%;
}
.box {
  -webkit-box-shadow: 0px 1px 16px 3px #ebeaea;
  box-shadow: 0px 1px 16px 3px #ebeaea;
  border-radius: 10px;
  margin-top: 20px;
  margin-left: 30px;
  background: #ffffff;
  overflow: hidden;
}
ul#menu li {
  display: inline;
  /* margin-left: 4px; */
}
.gray {
  background: lightgray;
}
.category {
  font-size: 18px !important;
  font-weight: bold;
  padding-left: 2%;
}
.leftdate {
  float: left;
  padding-top: 70px;
  /* margin-bottom: 10px; */
}
.disclaimer {
  text-align: center;
  color: #006ac3;
  padding-top: 26px;
  /* margin-bottom: 5px; */
}
.pagenum {
  float: right;
  /* margin-bottom: 30px; */
}
.footer {
  position: absolute;
  bottom: 30px;
  left: 30px;
  right: 30px;
  border-top: 1px solid #888;
  text-align: center;
  color: #888;
}
.heading {
  background-color: lightgray;
  width: 100%;
  font-weight: bold;
  display: block;
  padding-left: 2%;
}
.pdleftright {
  margin-left: 5%;
  margin-right: 5%;
}
ol {
  list-style-type: none;
  font-size: 18px;
}
.arrow-list {
  list-style-type: "*";
}
.page-template .header {
  top: 20px;
  border-bottom: 1px solid #000;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/generateAssessmentPDF.vue